import Rdp from './pairing_cards_v2/Rdp_v2';
import PropTypes from 'prop-types';
import { LegacyPdpRdpModal } from './LegacyPdpRdpModal';

// Because the Modal component is injecting the closeModal and openModal prop
// we need to wrap the RDP in a Component
const RDPWrapper = ({
  spicyTags,
  swappableRecipes,
  onPairingSwap,
  isCustomizationPage,
  closeModal,
  pairing,
  segmentPath,
  customerId,
}) => {
  return (
    <Rdp
      segmentPath={segmentPath}
      customerId={customerId}
      pairing={pairing}
      swappableRecipes={swappableRecipes}
      closeModal={closeModal}
      isCustomizationPage={isCustomizationPage}
      onPairingSwap={onPairingSwap}
      spicyTags={spicyTags}
    />
  );
};

const RDPModal = ({
  swappableRecipes,
  segmentPath,
  customerId,
  pairing,
  visible,
  onClose,
  children,
  isCustomizationPage,
  onPairingSwap,
  spicyTags,
}) => {
  if (pairing === null || pairing === undefined) {
    return null;
  }

  return (
    <LegacyPdpRdpModal
      testid="rdp-modal-container"
      onClose={onClose}
      visible={visible}
      ariaLabel={`${pairing.name} modal`}
    >
      <RDPWrapper
        swappableRecipes={swappableRecipes}
        spicyTags={spicyTags}
        onPairingSwap={onPairingSwap}
        isCustomizationPage={isCustomizationPage}
        segmentPath={segmentPath}
        customerId={customerId}
        pairing={pairing}
      />
    </LegacyPdpRdpModal>
  );
};

RDPModal.propTypes = {
  pairing: PropTypes.any,
  visible: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  customizatioData: PropTypes.object,
};

export default RDPModal;
